import React from "react";

import Container from "@mui/material/Container";

import WebsiteFooter from "components/Footer/WebsiteFooter";
import IbanHeader from "components/Header/IbanHeader";

interface LayoutProps {
  children?: React.ReactNode;
}

const WebsiteLayout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <>
      <IbanHeader />
      <Container sx={{ flex: 1 }}>{children}</Container>
      <WebsiteFooter />
    </>
  );
};

export default WebsiteLayout;
